'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, forwardRef, isValidElement } from 'react';
import { cn } from '../../utils/cn';
import { usePaginationContext } from './Context';
import { paginationTheme } from './theme';
const PaginationItem = forwardRef(({ className, children, active = false, asChild, ...props }, ref) => {
    const { shape = 'rounded' } = usePaginationContext();
    const { item } = paginationTheme;
    if (asChild && isValidElement(children)) {
        return cloneElement(children, {
            itemRef: ref,
            ...props,
        });
    }
    return (_jsx("li", { children: _jsx("button", { ...props, ref: ref, className: cn(item.base, item.active[active ? 'on' : 'off'], item.shape[shape], className), children: children }) }));
});
PaginationItem.displayName = 'PaginationItem';
export { PaginationItem };
